import gql from 'graphql-tag'

const createOrUpdateAccomplishmentsMutation = gql`
  mutation createOrUpdateAccomplishments($expertId: String!, $input: AccomplishmentsInput!) {
    createOrUpdateAccomplishments(expertId: $expertId, input: $input) {
      newEntities {
        ... on Publication {
          id
        }
      }
      updatedEntities
    }
  }
`

export default createOrUpdateAccomplishmentsMutation
